import React from 'react'

/**
 * Button - Glassmorphism styled button component
 * Supports multiple variants and sizes
 */
const Button = ({ 
  children, 
  variant = 'default', 
  size = 'md',
  className = '', 
  disabled = false,
  ...props 
}) => {
  const variants = {
    default: 'glass-button',
    primary: 'glass-button-primary',
    secondary: 'glass-button bg-primary-800 hover:bg-primary-700'
  }

  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  }

  const baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed'
  const variantClasses = variants[variant] || variants.default
  const sizeClasses = sizes[size] || sizes.md
  
  const combinedClasses = `${baseClasses} ${variantClasses} ${sizeClasses} ${className}`.trim()

  return (
    <button 
      className={combinedClasses} 
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
